@if (typed?.endsWith('field')) {
<div class="mb-3">
    <label class="form-label" [for]="name">
        {{question}}
    </label>
    <input class="form-control" [type]="typed!.replace('-field', '')" [name]="name" [id]="name" [value]="answer"
        [max]="max" [min]="min" (change)="emitField($event)" />
</div>
}
@else if (typed === 'textarea') {
<div class="mb-3">
    <label class="form-label" [for]="name">
        {{question}}
    </label>
    <textarea class="form-control" [name]="name" [id]="name" (change)="emitField($event)" rows="7">{{answer}}</textarea>
</div>
}
@else if (typed === 'radio-select') {
{{question}}
<br />
@for (option of options; track option; let index = $index, last = $last) {
<div class="form-check">
    <input class="form-check-input" type="radio" [name]="name" [id]="name + '_' + index" [value]="option"
        [checked]="answer == option || (showOtherField && last)" (change)="emitRadio($event, other && last)">
    <label class="form-check-label" [for]="name + '_' + index">
        {{option}}
    </label>
</div>
@if (showOtherField && last) {
<div class="mb-3">
    <input class="form-control" type="text" [name]="name" [value]="answer === option ? '' : answer"
        (change)="emitField($event)" />
</div>
}
}
}
@else if (typed === 'dropdown-select') {
{{question}}
<br />
<div class="input-group">
    <select [name]="name" class="form-select" (change)="emitDropdown($event)">
        <option></option>
        @for (option of options; track option; let index = $index, last = $last) {
        <option [value]="option" [selected]="answer == option || (showOtherField && last)">
            {{option}}
        </option>
        @if (showOtherField && last) {
        <option [selected]="showOtherField" [value]="option">{{option}}</option>
        }
        }
    </select>
    @if (showOtherField && options) {
    <input class="form-control" type="text" [name]="name" [value]="answer === options[options.length -1] ? '' : answer"
        (change)="emitField($event)" />
    }
</div>
}
@else if (typed === 'checkbox-select') {
{{question}}
<br />
@for (option of options; track option; let index = $index, last = $last) {
<div class="form-check">
    <input class="form-check-input" type="checkbox" [name]="name" [id]="name + '_' + index" [value]="option"
        [checked]="hasSelectedOption(option, last)" (change)="emitCheckbox($event, last)">
    <label class="form-check-label" [for]="name + '_' + index">
        {{option}}
    </label>
</div>
@if (showOtherField && last) {
<div class="mb-3">
    <input class="form-control" type="text" [name]="name" [value]="answer === option ? '' : answer"
        (change)="emitField($event)" />
</div>
}
}
}
@else if (typed === 'checkbox') {
<div class="form-check form-check-inline">
    <label class="form-check-label" [for]="name">{{question}}</label>
    <input class="form-check-input" type="checkbox" [name]="name" [id]="name" [checked]="answer"
        (change)="emit(!answer)" />
</div>
}
@else if (typed === 'yesno') {
{{question}}
<br />
<div class="form-check">
    <input class="form-check-input" type="radio" [name]="name" [id]="name + '_yes'" value="1" [checked]="answer"
        (change)="emit(!answer)">
    <label class="form-check-label" [for]="name + '_yes'" i18n>
        Yes
    </label>
</div>
<div class="form-check">
    <input class="form-check-input" type="radio" [name]="name" [id]="name + '_no'" value="0" (change)="emit(!answer)">
    <label class="form-check-label" [for]="name + '_no'" i18n>
        No
    </label>
</div>
}
@else {
Unknown question type {{typed}}.
}